// extracted by mini-css-extract-plugin
module.exports = {"cls1":"JsDocDescription-CssProp1_div-module--cls1--1KYlW","cls2":"JsDocDescription-CssProp1_div-module--cls2--2FYL6 JsDocDescription-CssProp1_div-module--cls1--1KYlW"};